const crypto = require('crypto');
const algorithm = 'aes-128-cbc';
const key = 'VY37an96bl5SxQST'

/* AES加密
   word: 需要加解密的文本
   key: 加解密的秘钥
   iv: 偏移量，最短8位数，ECB模式不需要此参数
*/
export function Encrypt(word) {
    let srcs = JSON.stringify(word);
    let iv = crypto.randomBytes(16); // 16位的随机数
	let cipher = crypto.createCipheriv(algorithm, Buffer.from(key), iv);
	let encrypted = cipher.update(srcs);
	encrypted = Buffer.concat([encrypted, cipher.final()]);
    let ivBuffer = Buffer.from(iv, 'utf8');
	let allBuffer = Buffer.concat([ivBuffer, encrypted]);
	return allBuffer.toString('base64');
}

// AES解密
export function Decrypt(word) {
	let data = Buffer.from(word, 'base64');
	let iv = data.slice(0, 16);
	let signData = data.slice(16);
	let decipher = crypto.createDecipheriv(algorithm, Buffer.from(key), iv);
	let decrypted = decipher.update(signData);
	decrypted = Buffer.concat([decrypted, decipher.final()]);
	return decrypted.toString();
}
